/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestProgressionMilestone } from './QuestProgressionMilestone';
import {
    QuestProgressionMilestoneFromJSON,
    QuestProgressionMilestoneFromJSONTyped,
    QuestProgressionMilestoneToJSON,
    QuestProgressionMilestoneToJSONTyped,
} from './QuestProgressionMilestone';

/**
 * 
 * @export
 * @interface QuestLeaderboardProfile
 */
export interface QuestLeaderboardProfile {
    /**
     * 
     * @type {string}
     * @memberof QuestLeaderboardProfile
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof QuestLeaderboardProfile
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof QuestLeaderboardProfile
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof QuestLeaderboardProfile
     */
    userId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestLeaderboardProfile
     */
    isComplete: boolean;
    /**
     * 
     * @type {number}
     * @memberof QuestLeaderboardProfile
     */
    claimedAt?: number;
    /**
     * When the per-user completion-window clock started (stamped once on first observed unlock).
     * @type {number}
     * @memberof QuestLeaderboardProfile
     */
    windowStartedAt?: number;
    /**
     * Per-user completion deadline (windowStartedAt + completionWindowDays). Unset = no window.
     * @type {number}
     * @memberof QuestLeaderboardProfile
     */
    deadlineAt?: number;
    /**
     * Derived at read time (deadlineAt < now && !isComplete). Never stored.
     * @type {boolean}
     * @memberof QuestLeaderboardProfile
     */
    isExpired?: boolean;
    /**
     * 
     * @type {number}
     * @memberof QuestLeaderboardProfile
     */
    lastStatReset?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestLeaderboardProfile
     */
    questConfigId?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestLeaderboardProfile
     */
    pointsReset?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestLeaderboardProfile
     */
    pointsTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestLeaderboardProfile
     */
    pointsLinked?: number;
    /**
     * Map of segment index to entries earned during that segment (for Challenge quests)
     * @type {{ [key: string]: number; }}
     * @memberof QuestLeaderboardProfile
     */
    entriesBySegment?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: QuestProgressionMilestone; }}
     * @memberof QuestLeaderboardProfile
     */
    progression: { [key: string]: QuestProgressionMilestone; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof QuestLeaderboardProfile
     */
    prerequisites: { [key: string]: boolean; };
    /**
     * 
     * @type {string}
     * @memberof QuestLeaderboardProfile
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestLeaderboardProfile
     */
    gravatar?: string;
}

/**
 * Check if a given object implements the QuestLeaderboardProfile interface.
 */
export function instanceOfQuestLeaderboardProfile(value: object): value is QuestLeaderboardProfile {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('isComplete' in value) || value['isComplete'] === undefined) return false;
    if (!('progression' in value) || value['progression'] === undefined) return false;
    if (!('prerequisites' in value) || value['prerequisites'] === undefined) return false;
    return true;
}

export function QuestLeaderboardProfileFromJSON(json: any): QuestLeaderboardProfile {
    return QuestLeaderboardProfileFromJSONTyped(json, false);
}

export function QuestLeaderboardProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestLeaderboardProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'isComplete': json['isComplete'],
        'claimedAt': json['claimedAt'] == null ? undefined : json['claimedAt'],
        'windowStartedAt': json['windowStartedAt'] == null ? undefined : json['windowStartedAt'],
        'deadlineAt': json['deadlineAt'] == null ? undefined : json['deadlineAt'],
        'isExpired': json['isExpired'] == null ? undefined : json['isExpired'],
        'lastStatReset': json['lastStatReset'] == null ? undefined : json['lastStatReset'],
        'questConfigId': json['questConfigId'] == null ? undefined : json['questConfigId'],
        'pointsReset': json['pointsReset'] == null ? undefined : json['pointsReset'],
        'pointsTotal': json['pointsTotal'] == null ? undefined : json['pointsTotal'],
        'pointsLinked': json['pointsLinked'] == null ? undefined : json['pointsLinked'],
        'entriesBySegment': json['entriesBySegment'] == null ? undefined : json['entriesBySegment'],
        'progression': (mapValues(json['progression'], QuestProgressionMilestoneFromJSON)),
        'prerequisites': json['prerequisites'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'gravatar': json['gravatar'] == null ? undefined : json['gravatar'],
    };
}

export function QuestLeaderboardProfileToJSON(json: any): QuestLeaderboardProfile {
    return QuestLeaderboardProfileToJSONTyped(json, false);
}

export function QuestLeaderboardProfileToJSONTyped(value?: QuestLeaderboardProfile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'userId': value['userId'],
        'isComplete': value['isComplete'],
        'claimedAt': value['claimedAt'],
        'windowStartedAt': value['windowStartedAt'],
        'deadlineAt': value['deadlineAt'],
        'isExpired': value['isExpired'],
        'lastStatReset': value['lastStatReset'],
        'questConfigId': value['questConfigId'],
        'pointsReset': value['pointsReset'],
        'pointsTotal': value['pointsTotal'],
        'pointsLinked': value['pointsLinked'],
        'entriesBySegment': value['entriesBySegment'],
        'progression': (mapValues(value['progression'], QuestProgressionMilestoneToJSON)),
        'prerequisites': value['prerequisites'],
        'nickname': value['nickname'],
        'gravatar': value['gravatar'],
    };
}

